<template>
  <Footer />
</template>

<script>
const Footer = () =>
  import(/* webpackChunkName: "c-Footer" */ "../components/Footer.vue");

export default {
  components: {
    Footer,
  },
};
</script>
